import { toComma } from '@epi-helpers/commaHelper';

export const TransferMoneyFormFields = {
  Amount: 'amount',
  Method: 'method'
};

export const normalizeDecimalComma = (value?: number) =>
  value ? toComma(value) : '0';
